import React from 'react'
import Select from 'react-select'
import {defineMessages, injectIntl} from 'react-intl'
import R from 'ramda'

const messages = defineMessages({
  placeholder: {
    id: "Select...",
    defaultMessage: "Select..."
  },
  searchingText: {
    id: "Searching...",
    defaultMessage: "Searching..."
  },
  searchPromptText: {
    id: "Type to search",
    defaultMessage: "Type to search"    
  },
  noResultsText: {
    id: "No results found",
    defaultMessage: "No results found"
  },
  clearAllText: {
    id: "Clear all",
    defaultMessage: "Clear all"
  },
  clearValueText: {
    id: "Clear value",
    defaultMessage: "Clear value"
  }
})

const I18nSelect = (props) => {
  const intl = props.intl
  const m = {
    loadingPlaceholder: intl.formatMessage(messages.searchingText),
    placeholder: intl.formatMessage(messages.placeholder), // TODO Pouvoir passer le placeholder en paramètre pour tous les selects 
    searchingText: intl.formatMessage(messages.searchingText),
    searchPromptText: intl.formatMessage(messages.searchPromptText),
    noResultsText: intl.formatMessage(messages.noResultsText),
    clearAllText: intl.formatMessage(messages.clearAllText),
    clearValueText: intl.formatMessage(messages.clearValueText),
  }
  const p = R.pipe(R.dissoc('intl'), R.merge(m))(props)
  
  return p.async ? <Select.Async {...p}/> : <Select {...p}/>
}
export default injectIntl(I18nSelect)



/** WEBPACK FOOTER **
 ** ./app/components/I18nSelect.jsx
 **/